const { cELM, Wrap4Arrow, isNoneOfTheAbove, unique } = require("../../utils");
const Chat = require("../../chat");

//AR: needs to move to the backend
/*
const NONE_VALUES = [
  "none",
  "none of the above",
  "decline to answer",
  "skip",
  "not sure",
  "never",
  "unknown",
  "unsure",
  "nothing",
  "no obvious cause",
];*/

class MultiSelect {
  constructor(data) {
    this._data = data;
    this.options = unique(this._data.values.split("|"));
    this.element = cELM("div", "option-block");
    this.selectedOptions = [];

    this.createElement();
  }

  createElement() {
    const _self = this;
    const btnEl = cELM("div", "continue-button", getLngTxt("button.continue"));
    const btnWrp = Wrap4Arrow(btnEl);

    let nonEls = [];

    this.options.forEach(op => {
      op = op.trim();
      const _el = cELM("div", "option");

      _el.value = op;

      //if (NONE_VALUES.indexOf(op.toLowerCase()) > -1) {
      if (isNoneOfTheAbove(op.toLowerCase())) {
        // if it's special option clearing all others
        nonEls.push(_el);
        _el.onclick = function(evt) {
          let sibling = _el.parentNode.firstChild;
          while (sibling) {
            sibling.classList.remove("option-active");
            sibling = sibling.nextSibling;
          }

          _el.classList.add("option-active");

          btnEl.classList.add("continue-button-active");
          btnWrp.classList.add("arrow-active");
        };
      } else {
        _el.onclick = function(evt) {
          _el.classList.toggle("option-active");

          let sibling = _el.parentNode.firstChild;
          while (sibling) {
            if (sibling.value && isNoneOfTheAbove(sibling.value.toLowerCase()))
              sibling.classList.remove("option-active");

            sibling = sibling.nextSibling;
          }

          btnEl.classList.add("continue-button-active");
          btnWrp.classList.add("arrow-active");
        };
      }

      _el.innerHTML = '<div class="option-icon"></div><div class="option-text">' + op + "</div>";

      this.element.addELM(_el);
    });

    btnWrp.onclick = function(evt) {
      if (btnEl.classList.contains("continue-button-active")) {
        _self.selectedOptions = [];
        let sibling = btnWrp.parentNode.firstChild;
        while (sibling) {
          if (sibling.value && sibling.classList.contains("option-active")) {
            _self.selectedOptions.push(sibling.value);
          }

          sibling = sibling.nextSibling;
        }

        if (_self.selectedOptions.length > 0)
          Chat.default.send({text:_self.selectedOptions.join(", "),id:_self._data.id}, null, _self.element);
      }
    };

    this.element.addELM(btnWrp);
  }

  getELM() {
    return this.element;
  }

  getHTML() {
    return this.element;
  }

  reset() {
    let sibling = this.element.firstChild;
    while (sibling) {
      sibling.classList.remove("option-active");
      sibling.classList.remove("continue-button-active");
      sibling.classList.remove("arrow-active");

      sibling = sibling.nextSibling;
    }
    this.selectedOptions = [];
  }

  focus() {}
}

module.exports = MultiSelect;
